import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
    logContextFetchError,
    logErrorData,
    logLoadContext,
} from '../services/datadog';
import { IUseGetContextResData } from './../types';

export default function (): {
    loading: boolean;
    data: IUseGetContextResData | null;
    error: string;
    fetchContext: (skipLoading?: boolean) => void;
    setContext: (context: any) => void;
} {
    const { pathname } = useLocation();
    const cid = pathname.split('/')[2];
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [data, setData] = useState<IUseGetContextResData | null>(null);

    const validateImageUrl = (url: string) => {

        const img = new Image();
        img.src = url;

        return new Promise((resolve) => {
            img.onload = () => {
                resolve(true);
            };

            img.onerror = () => {
                resolve(false);
            };
        });
    }

    const fetchContext = async (skipLoading?: boolean) => {
        if (!cid) {
            return setError('No cid provided');
        }

        //Need to do this properly, dont want the loading spinner to appear when refreshing context on account-info page
        if (!skipLoading) {
            setLoading(true);
        }

        try {
            const result = await fetch(
                `${process.env.REACT_APP_API_BASE || ''}/v1/contexts/${cid}`,
                {
                    method: 'GET',
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_SUPERUSER_API_KEY}`,
                    },
                }
            );

            if (!result.ok || result.status !== 200) {
                logContextFetchError(cid);
                setLoading(false);
                return setError(`context id: "${cid}" is invalid`);
            }

            var responseData: IUseGetContextResData = await result.json();

            //check image
            if (responseData?.user?.logoUrl) {
                let isValid = await validateImageUrl(responseData?.user?.logoUrl)
                if (!isValid){
                    responseData.logoUrl = '';
                }
            }

            //logging
            if (Boolean(responseData)) {
                const {
                    cid,
                    user: { id, name },
                } = responseData;

                logLoadContext(cid, {
                    id,
                    name,
                });
            }
            setData(responseData);
            setLoading(false);
        } catch (error) {
            setError(error as string);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchContext();
    }, []);

    if (!!error && !data) {
        logErrorData(cid, error.toString(), data);
    }

    return { loading, error, data, fetchContext, setContext: setData };
}
